import { gql } from '@apollo/client'

export default gql(`
    mutation($id: String! $project: String) {
        deleteTag(
            input: {
                key: $id
            }
            project: $project
        ) {
            key
            name
        }
    }`
)
